import { Activity, Airplay, AlertCircle, AlertOctagon, AlertTriangle, AlignCenter, AlignJustify, AlignLeft, AlignRight, Anchor, Aperture, Archive, ArrowDown, ArrowDownCircle, ArrowDownLeft, ArrowDownRight, ArrowLeft, ArrowLeftCircle, ArrowRight, ArrowRightCircle, ArrowUp, ArrowUpCircle, ArrowUpLeft, ArrowUpRight, AtSign, Award, BarChart, BarChart2, Battery, BatteryCharging, Bell, BellOff, Bluetooth, Bold, Book, Bookmark, BookOpen, Box, Briefcase, Calendar, Camera, CameraOff, Cast, Check, CheckCircle, CheckSquare, ChevronDown, ChevronLeft, ChevronRight, ChevronsDown, ChevronsLeft, ChevronsRight, ChevronsUp, ChevronUp, Chrome, Circle, Clipboard, Clock, Cloud, CloudDrizzle, CloudLightning, CloudOff, CloudRain, CloudSnow, Code, Codepen, Codesandbox, Coffee, Columns, Command, Compass, Copy, CornerDownLeft, CornerDownRight, CornerLeftDown, CornerLeftUp, CornerRightDown, CornerRightUp, CornerUpLeft, CornerUpRight, Cpu, CreditCard, Crop, Crosshair, Database, Delete, Disc, Divide, DivideCircle, DivideSquare, DollarSign, Download, DownloadCloud, Dribbble, Droplet, Edit3 as Edit, ExternalLink, Eye, EyeOff, Facebook, FastForward, Feather, Figma, File, FileMinus, FilePlus, FileText, Film, Filter, Flag, Folder, FolderMinus, FolderPlus, Framer, Frown, Gift, GitBranch, GitCommit, GitHub, Gitlab, GitMerge, GitPullRequest, Globe, Grid, HardDrive, Hash, Headphones, Heart, HelpCircle, Hexagon, Home, Image, Inbox, Info, Instagram, Italic, Key, Layers, Layout, LifeBuoy, Link, Link2, Linkedin, List, Loader, Lock, LogIn, LogOut, Mail, Map, MapPin, Maximize, Maximize2, Meh, Menu, MessageCircle, MessageSquare, Mic, MicOff, Minimize, Minimize2, Minus, MinusCircle, MinusSquare, Monitor, Moon, MoreHorizontal, MoreVertical, MousePointer, Move, Music, Navigation, Navigation2, Octagon, Package, Paperclip, Pause, PauseCircle, PenTool, Percent, Phone, PhoneCall, PhoneForwarded, PhoneIncoming, PhoneMissed, PhoneOff, PhoneOutgoing, PieChart, Play, PlayCircle, Plus, PlusCircle, PlusSquare, Pocket, Power, Printer, Radio, RefreshCcw, RefreshCw, Repeat, Rewind, RotateCcw, RotateCw, Rss, Save, Scissors, Search, Send, Server, Settings, Share, Share2, Shield, ShieldOff, ShoppingBag, ShoppingCart, Shuffle, Sidebar, SkipBack, SkipForward, Slack, Slash, Sliders, Smartphone, Smile, Speaker, Square, Star, StopCircle, Sun, Sunrise, Sunset, Table, Tablet, Tag, Target, Terminal, Thermometer, ThumbsDown, ThumbsUp, ToggleLeft, ToggleRight, Tool, Trash2 as Trash, Trello, TrendingDown, TrendingUp, Triangle, Truck, Tv, Twitch, Twitter, Type, Umbrella, Underline, Unlock, Upload, UploadCloud, User, UserCheck, UserMinus, UserPlus, Users, UserX, Video, VideoOff, Voicemail, Volume, Volume1, Volume2, VolumeX, Watch, Wifi, WifiOff, Wind, X, XCircle, XOctagon, XSquare, Youtube, Zap, ZapOff, ZoomIn, ZoomOut, } from 'react-feather';
import { styled } from '../styled';
function wrapFeatherIcon(FeatherIconComponent) {
    var StyledFeatherIconComponent = styled(FeatherIconComponent)({});
    StyledFeatherIconComponent.defaultProps = {
        size: '1em',
        color: 'currentColor',
    };
    return StyledFeatherIconComponent;
}
export var ActivityIcon = wrapFeatherIcon(Activity);
export var AirplayIcon = wrapFeatherIcon(Airplay);
export var AlertCircleIcon = wrapFeatherIcon(AlertCircle);
export var AlertOctagonIcon = wrapFeatherIcon(AlertOctagon);
export var AlertTriangleIcon = wrapFeatherIcon(AlertTriangle);
export var AlignCenterIcon = wrapFeatherIcon(AlignCenter);
export var AlignJustifyIcon = wrapFeatherIcon(AlignJustify);
export var AlignLeftIcon = wrapFeatherIcon(AlignLeft);
export var AlignRightIcon = wrapFeatherIcon(AlignRight);
export var AnchorIcon = wrapFeatherIcon(Anchor);
export var ApertureIcon = wrapFeatherIcon(Aperture);
export var ArchiveIcon = wrapFeatherIcon(Archive);
export var ArrowDownIcon = wrapFeatherIcon(ArrowDown);
export var ArrowDownCircleIcon = wrapFeatherIcon(ArrowDownCircle);
export var ArrowDownLeftIcon = wrapFeatherIcon(ArrowDownLeft);
export var ArrowDownRightIcon = wrapFeatherIcon(ArrowDownRight);
export var ArrowLeftIcon = wrapFeatherIcon(ArrowLeft);
export var ArrowLeftCircleIcon = wrapFeatherIcon(ArrowLeftCircle);
export var ArrowRightIcon = wrapFeatherIcon(ArrowRight);
export var ArrowRightCircleIcon = wrapFeatherIcon(ArrowRightCircle);
export var ArrowUpIcon = wrapFeatherIcon(ArrowUp);
export var ArrowUpCircleIcon = wrapFeatherIcon(ArrowUpCircle);
export var ArrowUpLeftIcon = wrapFeatherIcon(ArrowUpLeft);
export var ArrowUpRightIcon = wrapFeatherIcon(ArrowUpRight);
export var AtSignIcon = wrapFeatherIcon(AtSign);
export var AwardIcon = wrapFeatherIcon(Award);
export var BarChartIcon = wrapFeatherIcon(BarChart);
export var BarChart2Icon = wrapFeatherIcon(BarChart2);
export var BatteryIcon = wrapFeatherIcon(Battery);
export var BatteryChargingIcon = wrapFeatherIcon(BatteryCharging);
export var BellIcon = wrapFeatherIcon(Bell);
export var BellOffIcon = wrapFeatherIcon(BellOff);
export var BluetoothIcon = wrapFeatherIcon(Bluetooth);
export var BoldIcon = wrapFeatherIcon(Bold);
export var BookIcon = wrapFeatherIcon(Book);
export var BookmarkIcon = wrapFeatherIcon(Bookmark);
export var BookOpenIcon = wrapFeatherIcon(BookOpen);
export var BoxIcon = wrapFeatherIcon(Box);
export var BriefcaseIcon = wrapFeatherIcon(Briefcase);
export var CalendarIcon = wrapFeatherIcon(Calendar);
export var CameraIcon = wrapFeatherIcon(Camera);
export var CameraOffIcon = wrapFeatherIcon(CameraOff);
export var CastIcon = wrapFeatherIcon(Cast);
export var CheckIcon = wrapFeatherIcon(Check);
export var CheckCircleIcon = wrapFeatherIcon(CheckCircle);
export var CheckSquareIcon = wrapFeatherIcon(CheckSquare);
export var ChevronDownIcon = wrapFeatherIcon(ChevronDown);
export var ChevronLeftIcon = wrapFeatherIcon(ChevronLeft);
export var ChevronRightIcon = wrapFeatherIcon(ChevronRight);
export var ChevronsDownIcon = wrapFeatherIcon(ChevronsDown);
export var ChevronsLeftIcon = wrapFeatherIcon(ChevronsLeft);
export var ChevronsRightIcon = wrapFeatherIcon(ChevronsRight);
export var ChevronsUpIcon = wrapFeatherIcon(ChevronsUp);
export var ChevronUpIcon = wrapFeatherIcon(ChevronUp);
export var ChromeIcon = wrapFeatherIcon(Chrome);
export var CircleIcon = wrapFeatherIcon(Circle);
export var ClipboardIcon = wrapFeatherIcon(Clipboard);
export var ClockIcon = wrapFeatherIcon(Clock);
export var CloudIcon = wrapFeatherIcon(Cloud);
export var CloudDrizzleIcon = wrapFeatherIcon(CloudDrizzle);
export var CloudLightningIcon = wrapFeatherIcon(CloudLightning);
export var CloudOffIcon = wrapFeatherIcon(CloudOff);
export var CloudRainIcon = wrapFeatherIcon(CloudRain);
export var CloudSnowIcon = wrapFeatherIcon(CloudSnow);
export var CodeIcon = wrapFeatherIcon(Code);
export var CodepenIcon = wrapFeatherIcon(Codepen);
export var CodesandboxIcon = wrapFeatherIcon(Codesandbox);
export var CoffeeIcon = wrapFeatherIcon(Coffee);
export var ColumnsIcon = wrapFeatherIcon(Columns);
export var CommandIcon = wrapFeatherIcon(Command);
export var CompassIcon = wrapFeatherIcon(Compass);
export var CopyIcon = wrapFeatherIcon(Copy);
export var CornerDownLeftIcon = wrapFeatherIcon(CornerDownLeft);
export var CornerDownRightIcon = wrapFeatherIcon(CornerDownRight);
export var CornerLeftDownIcon = wrapFeatherIcon(CornerLeftDown);
export var CornerLeftUpIcon = wrapFeatherIcon(CornerLeftUp);
export var CornerRightDownIcon = wrapFeatherIcon(CornerRightDown);
export var CornerRightUpIcon = wrapFeatherIcon(CornerRightUp);
export var CornerUpLeftIcon = wrapFeatherIcon(CornerUpLeft);
export var CornerUpRightIcon = wrapFeatherIcon(CornerUpRight);
export var CpuIcon = wrapFeatherIcon(Cpu);
export var CreditCardIcon = wrapFeatherIcon(CreditCard);
export var CropIcon = wrapFeatherIcon(Crop);
export var CrosshairIcon = wrapFeatherIcon(Crosshair);
export var DatabaseIcon = wrapFeatherIcon(Database);
export var DeleteIcon = wrapFeatherIcon(Delete);
export var DiscIcon = wrapFeatherIcon(Disc);
export var DivideIcon = wrapFeatherIcon(Divide);
export var DivideCircleIcon = wrapFeatherIcon(DivideCircle);
export var DivideSquareIcon = wrapFeatherIcon(DivideSquare);
export var DollarSignIcon = wrapFeatherIcon(DollarSign);
export var DownloadIcon = wrapFeatherIcon(Download);
export var DownloadCloudIcon = wrapFeatherIcon(DownloadCloud);
export var DribbbleIcon = wrapFeatherIcon(Dribbble);
export var DropletIcon = wrapFeatherIcon(Droplet);
export var EditIcon = wrapFeatherIcon(Edit);
export var ExternalLinkIcon = wrapFeatherIcon(ExternalLink);
export var EyeIcon = wrapFeatherIcon(Eye);
export var EyeOffIcon = wrapFeatherIcon(EyeOff);
export var FacebookIcon = wrapFeatherIcon(Facebook);
export var FastForwardIcon = wrapFeatherIcon(FastForward);
export var FeatherIcon = wrapFeatherIcon(Feather);
export var FigmaIcon = wrapFeatherIcon(Figma);
export var FileIcon = wrapFeatherIcon(File);
export var FileMinusIcon = wrapFeatherIcon(FileMinus);
export var FilePlusIcon = wrapFeatherIcon(FilePlus);
export var FileTextIcon = wrapFeatherIcon(FileText);
export var FilmIcon = wrapFeatherIcon(Film);
export var FilterIcon = wrapFeatherIcon(Filter);
export var FlagIcon = wrapFeatherIcon(Flag);
export var FolderIcon = wrapFeatherIcon(Folder);
export var FolderMinusIcon = wrapFeatherIcon(FolderMinus);
export var FolderPlusIcon = wrapFeatherIcon(FolderPlus);
export var FramerIcon = wrapFeatherIcon(Framer);
export var FrownIcon = wrapFeatherIcon(Frown);
export var GiftIcon = wrapFeatherIcon(Gift);
export var GitBranchIcon = wrapFeatherIcon(GitBranch);
export var GitCommitIcon = wrapFeatherIcon(GitCommit);
export var GitHubIcon = wrapFeatherIcon(GitHub);
export var GitlabIcon = wrapFeatherIcon(Gitlab);
export var GitMergeIcon = wrapFeatherIcon(GitMerge);
export var GitPullRequestIcon = wrapFeatherIcon(GitPullRequest);
export var GlobeIcon = wrapFeatherIcon(Globe);
export var GridIcon = wrapFeatherIcon(Grid);
export var HardDriveIcon = wrapFeatherIcon(HardDrive);
export var HashIcon = wrapFeatherIcon(Hash);
export var HeadphonesIcon = wrapFeatherIcon(Headphones);
export var HeartIcon = wrapFeatherIcon(Heart);
export var HelpCircleIcon = wrapFeatherIcon(HelpCircle);
export var HexagonIcon = wrapFeatherIcon(Hexagon);
export var HomeIcon = wrapFeatherIcon(Home);
export var ImageIcon = wrapFeatherIcon(Image);
export var InboxIcon = wrapFeatherIcon(Inbox);
export var InfoIcon = wrapFeatherIcon(Info);
export var InstagramIcon = wrapFeatherIcon(Instagram);
export var ItalicIcon = wrapFeatherIcon(Italic);
export var KeyIcon = wrapFeatherIcon(Key);
export var LayersIcon = wrapFeatherIcon(Layers);
export var LayoutIcon = wrapFeatherIcon(Layout);
export var LifeBuoyIcon = wrapFeatherIcon(LifeBuoy);
export var LinkIcon = wrapFeatherIcon(Link);
export var Link2Icon = wrapFeatherIcon(Link2);
export var LinkedinIcon = wrapFeatherIcon(Linkedin);
export var ListIcon = wrapFeatherIcon(List);
export var LoaderIcon = wrapFeatherIcon(Loader);
export var LockIcon = wrapFeatherIcon(Lock);
export var LogInIcon = wrapFeatherIcon(LogIn);
export var LogOutIcon = wrapFeatherIcon(LogOut);
export var MailIcon = wrapFeatherIcon(Mail);
export var MapIcon = wrapFeatherIcon(Map);
export var MapPinIcon = wrapFeatherIcon(MapPin);
export var MaximizeIcon = wrapFeatherIcon(Maximize);
export var Maximize2Icon = wrapFeatherIcon(Maximize2);
export var MehIcon = wrapFeatherIcon(Meh);
export var MenuIcon = wrapFeatherIcon(Menu);
export var MessageCircleIcon = wrapFeatherIcon(MessageCircle);
export var MessageSquareIcon = wrapFeatherIcon(MessageSquare);
export var MicIcon = wrapFeatherIcon(Mic);
export var MicOffIcon = wrapFeatherIcon(MicOff);
export var MinimizeIcon = wrapFeatherIcon(Minimize);
export var Minimize2Icon = wrapFeatherIcon(Minimize2);
export var MinusIcon = wrapFeatherIcon(Minus);
export var MinusCircleIcon = wrapFeatherIcon(MinusCircle);
export var MinusSquareIcon = wrapFeatherIcon(MinusSquare);
export var MonitorIcon = wrapFeatherIcon(Monitor);
export var MoonIcon = wrapFeatherIcon(Moon);
export var MoreHorizontalIcon = wrapFeatherIcon(MoreHorizontal);
export var MoreVerticalIcon = wrapFeatherIcon(MoreVertical);
export var MousePointerIcon = wrapFeatherIcon(MousePointer);
export var MoveIcon = wrapFeatherIcon(Move);
export var MusicIcon = wrapFeatherIcon(Music);
export var NavigationIcon = wrapFeatherIcon(Navigation);
export var Navigation2Icon = wrapFeatherIcon(Navigation2);
export var OctagonIcon = wrapFeatherIcon(Octagon);
export var PackageIcon = wrapFeatherIcon(Package);
export var PaperclipIcon = wrapFeatherIcon(Paperclip);
export var PauseIcon = wrapFeatherIcon(Pause);
export var PauseCircleIcon = wrapFeatherIcon(PauseCircle);
export var PenToolIcon = wrapFeatherIcon(PenTool);
export var PercentIcon = wrapFeatherIcon(Percent);
export var PhoneIcon = wrapFeatherIcon(Phone);
export var PhoneCallIcon = wrapFeatherIcon(PhoneCall);
export var PhoneForwardedIcon = wrapFeatherIcon(PhoneForwarded);
export var PhoneIncomingIcon = wrapFeatherIcon(PhoneIncoming);
export var PhoneMissedIcon = wrapFeatherIcon(PhoneMissed);
export var PhoneOffIcon = wrapFeatherIcon(PhoneOff);
export var PhoneOutgoingIcon = wrapFeatherIcon(PhoneOutgoing);
export var PieChartIcon = wrapFeatherIcon(PieChart);
export var PlayIcon = wrapFeatherIcon(Play);
export var PlayCircleIcon = wrapFeatherIcon(PlayCircle);
export var PlusIcon = wrapFeatherIcon(Plus);
export var PlusCircleIcon = wrapFeatherIcon(PlusCircle);
export var PlusSquareIcon = wrapFeatherIcon(PlusSquare);
export var PocketIcon = wrapFeatherIcon(Pocket);
export var PowerIcon = wrapFeatherIcon(Power);
export var PrinterIcon = wrapFeatherIcon(Printer);
export var RadioIcon = wrapFeatherIcon(Radio);
export var RefreshCcwIcon = wrapFeatherIcon(RefreshCcw);
export var RefreshCwIcon = wrapFeatherIcon(RefreshCw);
export var RepeatIcon = wrapFeatherIcon(Repeat);
export var RewindIcon = wrapFeatherIcon(Rewind);
export var RotateCcwIcon = wrapFeatherIcon(RotateCcw);
export var RotateCwIcon = wrapFeatherIcon(RotateCw);
export var RssIcon = wrapFeatherIcon(Rss);
export var SaveIcon = wrapFeatherIcon(Save);
export var ScissorsIcon = wrapFeatherIcon(Scissors);
export var SearchIcon = wrapFeatherIcon(Search);
export var SendIcon = wrapFeatherIcon(Send);
export var ServerIcon = wrapFeatherIcon(Server);
export var SettingsIcon = wrapFeatherIcon(Settings);
export var ShareIcon = wrapFeatherIcon(Share);
export var Share2Icon = wrapFeatherIcon(Share2);
export var ShieldIcon = wrapFeatherIcon(Shield);
export var ShieldOffIcon = wrapFeatherIcon(ShieldOff);
export var ShoppingBagIcon = wrapFeatherIcon(ShoppingBag);
export var ShoppingCartIcon = wrapFeatherIcon(ShoppingCart);
export var ShuffleIcon = wrapFeatherIcon(Shuffle);
export var SidebarIcon = wrapFeatherIcon(Sidebar);
export var SkipBackIcon = wrapFeatherIcon(SkipBack);
export var SkipForwardIcon = wrapFeatherIcon(SkipForward);
export var SlackIcon = wrapFeatherIcon(Slack);
export var SlashIcon = wrapFeatherIcon(Slash);
export var SlidersIcon = wrapFeatherIcon(Sliders);
export var SmartphoneIcon = wrapFeatherIcon(Smartphone);
export var SmileIcon = wrapFeatherIcon(Smile);
export var SpeakerIcon = wrapFeatherIcon(Speaker);
export var SquareIcon = wrapFeatherIcon(Square);
export var StarIcon = wrapFeatherIcon(Star);
export var StopCircleIcon = wrapFeatherIcon(StopCircle);
export var SunIcon = wrapFeatherIcon(Sun);
export var SunriseIcon = wrapFeatherIcon(Sunrise);
export var SunsetIcon = wrapFeatherIcon(Sunset);
export var TableIcon = wrapFeatherIcon(Table);
export var TabletIcon = wrapFeatherIcon(Tablet);
export var TagIcon = wrapFeatherIcon(Tag);
export var TargetIcon = wrapFeatherIcon(Target);
export var TerminalIcon = wrapFeatherIcon(Terminal);
export var ThermometerIcon = wrapFeatherIcon(Thermometer);
export var ThumbsDownIcon = wrapFeatherIcon(ThumbsDown);
export var ThumbsUpIcon = wrapFeatherIcon(ThumbsUp);
export var ToggleLeftIcon = wrapFeatherIcon(ToggleLeft);
export var ToggleRightIcon = wrapFeatherIcon(ToggleRight);
export var ToolIcon = wrapFeatherIcon(Tool);
export var TrashIcon = wrapFeatherIcon(Trash);
export var TrelloIcon = wrapFeatherIcon(Trello);
export var TrendingDownIcon = wrapFeatherIcon(TrendingDown);
export var TrendingUpIcon = wrapFeatherIcon(TrendingUp);
export var TriangleIcon = wrapFeatherIcon(Triangle);
export var TruckIcon = wrapFeatherIcon(Truck);
export var TvIcon = wrapFeatherIcon(Tv);
export var TwitchIcon = wrapFeatherIcon(Twitch);
export var TwitterIcon = wrapFeatherIcon(Twitter);
export var TypeIcon = wrapFeatherIcon(Type);
export var UmbrellaIcon = wrapFeatherIcon(Umbrella);
export var UnderlineIcon = wrapFeatherIcon(Underline);
export var UnlockIcon = wrapFeatherIcon(Unlock);
export var UploadIcon = wrapFeatherIcon(Upload);
export var UploadCloudIcon = wrapFeatherIcon(UploadCloud);
export var UserIcon = wrapFeatherIcon(User);
export var UserCheckIcon = wrapFeatherIcon(UserCheck);
export var UserMinusIcon = wrapFeatherIcon(UserMinus);
export var UserPlusIcon = wrapFeatherIcon(UserPlus);
export var UsersIcon = wrapFeatherIcon(Users);
export var UserXIcon = wrapFeatherIcon(UserX);
export var VideoIcon = wrapFeatherIcon(Video);
export var VideoOffIcon = wrapFeatherIcon(VideoOff);
export var VoicemailIcon = wrapFeatherIcon(Voicemail);
export var VolumeIcon = wrapFeatherIcon(Volume);
export var Volume1Icon = wrapFeatherIcon(Volume1);
export var Volume2Icon = wrapFeatherIcon(Volume2);
export var VolumeXIcon = wrapFeatherIcon(VolumeX);
export var WatchIcon = wrapFeatherIcon(Watch);
export var WifiIcon = wrapFeatherIcon(Wifi);
export var WifiOffIcon = wrapFeatherIcon(WifiOff);
export var WindIcon = wrapFeatherIcon(Wind);
export var XIcon = wrapFeatherIcon(X);
export var XCircleIcon = wrapFeatherIcon(XCircle);
export var XOctagonIcon = wrapFeatherIcon(XOctagon);
export var XSquareIcon = wrapFeatherIcon(XSquare);
export var YoutubeIcon = wrapFeatherIcon(Youtube);
export var ZapIcon = wrapFeatherIcon(Zap);
export var ZapOffIcon = wrapFeatherIcon(ZapOff);
export var ZoomInIcon = wrapFeatherIcon(ZoomIn);
export var ZoomOutIcon = wrapFeatherIcon(ZoomOut);
